<template>
  <v-dialog v-model="show" width="720" content-class="popup-wrap-1" persistent>
    <div>
      <div class="pa-8">
        <p class="title-type-4">{{ propsInventory.name }} 소재 이력</p>
        <p class="form-coment-1 mt-3">
          <v-icon>mdi-alert-circle-outline</v-icon>
          선택한 지면의 광고주의 소재 이력만 출력 됩니다.
        </p>
        <div class="table-wrap">
          <v-radio-group v-model="pickedFile">
            <v-data-table
              :headers="boardHeaders"
              :items="boardLists"
              :page.sync="page"
              :items-per-page="itemsPerPage"
              class="board-list-1"
              hide-default-footer
              @page-count="pageCount = $event"
            >
              <template v-slot:body="{ items, headers }">
                <tbody v-if="items.length > 0">
                  <tr v-for="(item, index) in items" :key="index">
                    <td class="pl-5">
                      <v-radio
                        :value="item"
                        color="#fecd00"
                        class="radio-type-1"
                      ></v-radio>
                    </td>
                    <td>
                      <a href="" @click.prevent="preview(item)">{{
                        item.name
                      }}</a>
                    </td>
                    <td>
                      {{ item.campaign.start_at | moment('YYYY.MM.DD') }} ~
                      {{ item.campaign.end_at | moment('YYYY.MM.DD') }}
                    </td>
                    <td>
                      {{ item.campaign.name }}
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td :colspan="headers.length" style="text-align: center">
                      선택한 지면에 동일 광고주/대행사가 진행한 캠페인 소재가
                      없습니다.
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-radio-group>
        </div>

        <div class="d-flex justify-end mt-6">
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fff"
            class="button-type-1"
            @click="show = false"
          >
            취소
          </v-btn>
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fecd06"
            class="button-type-1 ml-4"
            @click.stop="historyImgPick"
          >
            확인
          </v-btn>
        </div>
      </div>

      <SystemAlert v-model="showSystemAlert">
        <div slot="noti-text">{{ logResult }}</div>
        <div slot="noti-btns">
          <v-btn
            large
            depressed
            max-height="40px"
            min-width="104px"
            color="#fecd06"
            class="button-type-1"
            @click.stop="show = false"
          >
            확인
          </v-btn>
        </div>
      </SystemAlert>
      <div v-if="showPreview">
        <PreviewResourceModal
          v-model="showPreview"
          :propsItem="propsInventory"
          :propsFileItem="fileItem"
        />
      </div>
    </div>
  </v-dialog>
</template>

<script>
import bus from '@/utils/bus';

import SystemAlert from '~@/modal/SystemAlert.vue';
import { resourcesHistoryToAdviertiser } from '@/api/advertiser';
import PreviewResourceModal from '~@/modal/PreviewResourceModal.vue';

export default {
  props: {
    value: Boolean,
    propsAdvertiserId: String,
    propsInventory: Object,
  },
  components: { SystemAlert, PreviewResourceModal },
  data: () => ({
    showSystemAlert: false,
    logResult: '',
    showPreview: false,
    pageSel: ['10', '25', '50', '100'],
    pageSelChoice: '10',
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    boardLists: [],
    boardHeaders: [
      {
        text: '',
        value: '',
        width: '10%',
        sortable: false,
        filterable: false,
      },
      {
        text: '소재명',
        value: 'name',
        width: '30%',
        sortable: false,
        filterable: false,
      },
      {
        text: '캠페인기간',
        value: 'campaign',
        width: '30%',
        sortable: false,
      },
      {
        text: '캠페인명',
        value: 'campaign.name',
        width: '30%',
        sortable: false,
        filterable: false,
      },
    ],
    radioColumn: null,
    pickedFile: null,
    fileItem: {},
  }),
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    inventory: {
      get() {
        return this.propsInventory;
      },
      set(value) {
        this.propsInventory = value;
      },
    },
  },
  methods: {
    async getResourceHistory() {
      try {
        const advertiserId = this.propsAdvertiserId;
        const inventoryId = this.propsInventory.id;
        const { data } = await resourcesHistoryToAdviertiser(
          advertiserId,
          inventoryId,
        );
        let boardLists = [];
        boardLists = data.list.filter(item => item.type === 1);
        this.boardLists = boardLists;

        bus.$emit('end:spinner');
      } catch (error) {
        console.log(error.response);
        bus.$emit('end:spinner');
      }
    },
    changeRadio(item) {
      this.pickedFile = item.file;
    },
    preview(item) {
      this.showPreview = true;
      this.fileItem = item;
    },
    historyImgPick() {
      this.show = false;
      this.$emit('historyImgregitst', this.pickedFile);
      this.pickedFile = null;
    },
  },
  async created() {
    //bus.$emit('start:spinner');
    await this.getResourceHistory();
  },
};
</script>
